import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  label: {
    color: '#0F0F0F',
    fontFamily: '"Readex Pro"',
    fontSize: 14,
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: '0.56px',
  },
  formControlStyle: {
    '&.MuiFormControl-root': {
      width: '100%',
      marginTop: 8,
    },
    '& .MuiSelect-select': {
      padding: 11,
    },
  },
  valueLocationNone: {
    height: 15,
  },
  wrapIconLocation: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  iconAddLocation: {
    '&.MuiSvgIcon-root': {
      width: 24,
      height: 24,
      marginLeft: 10,
    },
  },
  textCreateItem: {
    fontSize: 16,
    marginLeft: 5,
    width: '100%',
  },
}));

export default useStyles;
